import {PAID_PLANS_APP_ID, PAID_PLANS_SECTION_ID} from '@wix/wix-events-commons-statics'

export const isPaidPlansInstalled = wixCodeApi =>
  Promise.resolve(
    wixCodeApi.site.isAppSectionInstalled({
      appDefinitionId: PAID_PLANS_APP_ID,
      sectionId: PAID_PLANS_SECTION_ID,
    }),
  )
